<app-header></app-header>

<!-- Page Header Start -->
<div class="container-fluid page-header py-5">
    <div class="container text-center pd-t-120 pd-b-120">
        <h1 class="display-5 text-white mb-4">Our Portfolio</h1>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
                <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
                <li class="breadcrumb-item"><a routerLink="/">Pages</a></li>
                <li class="breadcrumb-item" aria-current="page">Portfolio</li>
            </ol>
        </nav>
    </div>
</div>
<!-- Page Header End -->

<!-- Fact Start -->
<div class="container-fluid bg-color-secondary py-5">
  <div class="container">
    <div class="row">
      
      <!-- Loop over facts array using *ngFor -->
      <div *ngFor="let fact of facts" class="col-lg-3">
        <div class="d-flex counter">
          <h1 class="me-3 color-dark counter-value">{{ fact.value }}</h1>
          <h5 class="text-white mt-1">{{ fact.label }}</h5>
        </div>
      </div>

    </div>
  </div>
</div>
<!-- Fact End -->

<!-- Portfolio Start -->
<div class="container-fluid project py-5 mb-5">
  <div class="container">
    <div class="text-center mx-auto pb-5" style="max-width: 600px;">
      <h5 class="color-primary">Our Portfolio</h5>
      <h1>Our Recently Completed Projects</h1>
    </div>
    
    <div class="row g-5">
      
      <!-- Loop over projects array using *ngFor -->
      <div *ngFor="let project of projects" class="col-md-6 col-lg-4">
        
        <div class="project-item">
          <div class="project-img">
            <img [src]="project.image" class="img-fluid w-100 rounded" [alt]="project.title">
            <div class="project-content">
              <a [routerLink]="project.link" class="text-center">
                <h5 class="color-dark">{{ project.title }}</h5>
                <p class="m-0 text-white">{{ project.category }}</p>
              </a>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>
<!-- Portfolio End -->